import components from './components'
import VIEWS, { ViewCollection } from './views'

const VIEWS_MAPPING: ViewCollection = Object.keys(VIEWS).reduce((accum, key) => {
    const view = VIEWS[key]

    return { ...accum, [key]: { ...view, component: components[view.componentName as string] }}
}, { })

export default VIEWS_MAPPING